import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

//auth
import createPersistedState from "vuex-persistedstate";
import user from "./modules/user.js";


export default new Vuex.Store({
  state: {
    currUser: null,
    FirebaseFunctionsURL: 'https://europe-west2-thesciencecapital.cloudfunctions.net'
  },
  plugins: [createPersistedState()],
  getters: {
    currUser(state) {
      // console.log("")
      return state.currUser;
    },
    FirebaseFunctionsURL(state) {
      return state.FirebaseFunctionsURL;
    }
  },
  mutations: {
    setUser(state, payload) {
      state.currUser = payload;
      //console.log("setUser: " + JSON.stringify(state.currUser))
    },
  },
  actions: {
  },
  modules: {
    user: user
  }
})
